import { FC, PropsWithChildren } from 'react';
import {
  Box,
  Stack,
  StackProps,
  Link,
} from 'material-hu';
import { Link as RouterLink } from 'react-router-dom';
import humandLogo from 'src/assets/humand.svg';

export type AuthLayoutProps =
  PropsWithChildren<StackProps & {
    showLogo?: boolean,
  }>;

export const AuthLayout: FC<AuthLayoutProps> = (props) => {
  const {
    showLogo = true,
    sx,
    children,
    ...stackProps
  } = props;

  return (
    <Stack
      sx={{
        minHeight: '100vh',
        py: 2,
        ...sx,
      }}
      spacing={8}
      justifyContent="center"
      alignItems="center"
      {...stackProps}
    >
      {showLogo && (
        <Link
          component={RouterLink}
          to="/"
          sx={{ width: '75%' }}
        >
          <Box
            component="img"
            alt="humand logo"
            src={humandLogo}
            sx={{ width: '100%' }}
          />
        </Link>
      )}
      {children}
    </Stack>
  );
};

export default AuthLayout;
